package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

// Google's four-color "G" mark. The hex values are FIXED by Google's sign-in branding guidelines —
// deliberately not theme tokens (a brand mark never re-tints for dark mode or app theming).
private val GoogleBlue = Color(0xFF4285F4)
private val GoogleGreen = Color(0xFF34A853)
private val GoogleYellow = Color(0xFFFBBC05)
private val GoogleRed = Color(0xFFEA4335)

private const val G_BLUE =
    "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
private const val G_GREEN =
    "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
private const val G_YELLOW =
    "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
private const val G_RED =
    "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"

/** Multicolor Google "G" for the sign-in button, per Google's branding guidelines. Decorative. */
@Composable
fun GoogleLogo(
    modifier: Modifier = Modifier,
    size: Dp = AppTheme.sizes.iconButton,
) {
    Image(
        painter = googleLogoPainter(),
        contentDescription = null,
        modifier = modifier.size(size),
        contentScale = ContentScale.Fit,
    )
}

@Composable
private fun googleLogoPainter(): Painter {
    val vector = remember {
        ImageVector.Builder(
            name = "GoogleG",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f,
        ).apply {
            listOf(G_BLUE to GoogleBlue, G_GREEN to GoogleGreen, G_YELLOW to GoogleYellow, G_RED to GoogleRed)
                .forEach { (path, color) ->
                    addPath(
                        pathData = PathParser().parsePathString(path).toNodes(),
                        fill = SolidColor(color),
                    )
                }
        }.build()
    }
    return rememberVectorPainter(vector)
}
